import styled from 'styled-components';

export const Container = styled.div`
  height: 31.25rem;
`;
